module.exports = __webpack_public_path__ + "static/media/toptal-2-cropped.f9935b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/toptal-2-cropped.png
// module id = 49
// module chunks = 0